import React from 'react'
import { Drawer } from '@mui/material'
import { element, any, func, bool } from 'prop-types'
import theme from '../../../theme/Default'
const MobileDrawer = ({
  drawerWidth,
  children,
  container,
  mobileOpen,
  actionToggle
}) => {
  const toggleDreawer = () => {
    actionToggle()
  }

  const styles = {
    display: { xs: 'block', sm: 'none' },
    '& .MuiDrawer-paper': {
      boxSizing: 'border-box',
      width: drawerWidth,
      backgroundColor: theme.palette.leitura.main
    }
  }

  return (
    <Drawer
      container={container}
      variant="temporary"
      open={mobileOpen}
      onClose={toggleDreawer}
      ModalProps={{
        keepMounted: true // Better open performance on mobile.
      }}
      sx={styles}
    >
      {children}
    </Drawer>
  )
}

MobileDrawer.propTypes = {
  drawerWidth: any,
  children: element,
  actionToggle: func,
  mobileOpen: bool,
  container: any
}

export default MobileDrawer
